import { useIntl } from 'react-intl'
import ModalsComponent from '../stories/atoms/modals'
import { modalSizeOptions } from '../stories/atoms/modals/constants'
import { buttonVariantOptions } from '../stories/atoms/button/constants'
import TextInputComponent from '../stories/molecules/text-input'
import { useState } from 'react'
import {
  RenameModalContainer,
  RenameModalNewNameContainer,
  RenameModalOldNameContainer
} from './styled-components'
import { textInputHintVariantOptions } from '../stories/molecules/text-input/constants'

const MAX_CHARACTERS = 64
const START_SHOW_COUNTER = MAX_CHARACTERS * 0.8

const RenameModal = ({
  headerTitle = '',
  isOpen = false,
  oldName = '',
  onClose = () => {},
  handleRename = () => {},
  isLoading = false,
  error = null
}) => {
  const [newName, setNewName] = useState('')

  const { formatMessage } = useIntl()

  const handleSubmit = () => {
    if (!newName) return null

    return handleRename(newName)
  }

  const handleCancel = () => {
    return onClose()
  }

  const onChangeNewTitle = (e) => {
    if (!e) return null
    const value = e.target.value

    setNewName(value)
  }

  const rightButtons = [
    {
      title: formatMessage({ id: 'cancel' }),
      variant: buttonVariantOptions['TERTIARY-HOLLOW'],
      action: handleCancel
    },
    {
      title: formatMessage({ id: 'rename' }),
      variant: buttonVariantOptions.PRIMARY,
      action: handleSubmit,
      isLoading,
      disabled: newName < 3
    }
  ]

  return (
    <ModalsComponent
      title={headerTitle}
      size={modalSizeOptions.SMALL}
      rightButtons={rightButtons}
      isOpen={isOpen}
      onClose={handleCancel}
    >
      <RenameModalContainer>
        <RenameModalOldNameContainer>
          <TextInputComponent value={oldName} readOnly />
        </RenameModalOldNameContainer>
        <RenameModalNewNameContainer>
          <TextInputComponent
            label={formatMessage({ id: 'tasks_newTitle' })}
            maxCharacters={MAX_CHARACTERS}
            showCounter={newName.length >= START_SHOW_COUNTER}
            clearButton={true}
            onChange={onChangeNewTitle}
            disabled={isLoading}
            hintMessage={error}
            hintShow={!!error}
            hintVariant={textInputHintVariantOptions.ERROR}
          />
        </RenameModalNewNameContainer>
      </RenameModalContainer>
    </ModalsComponent>
  )
}

export default RenameModal
